var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"application-wrapper"}},[_c('TopBarDesktop',{attrs:{"tab":"pro"}}),_vm._v(" "),_c('div',{staticClass:"secondary-menu go-pro"},[_c('div',{ref:"vueCustomScrollbar",staticClass:"secondary-menu-body"},[_c('ProfileSubscriptionCreate')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }